import React from 'react';
import { Lobby } from '../../components/Lobby';
import { InitialPropsProvider } from '../../context';
import { InitialProps } from '../../../lib/types/initialProps';

const App = (props: InitialProps) => (
  <InitialPropsProvider {...props}>
    <Lobby />
  </InitialPropsProvider>
);

export default App;
